import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { url as urlUtils } from '@tencent/wphk-base-utils';
import { WX_OAUTH_CODE, LOGIN_TOKEN, CONSUME_LOGIN_TOKEN_API } from './config';
/**
 * 检测token是否已经过期
 * @param timeDiffHex 时间戳差值16进制字符串
 * @returns true: 已过期、 false：未过期
 */
function checkTokenExpired(timeDiffHex) {
    const timeDiff = parseInt(timeDiffHex, 16); // 将16进制转换成10进制时间差值（秒）
    if (timeDiff) {
        const startTime = new Date(1704038400000); // 北京时间2024/1/1 00:00:00
        // token有效截止时间戳 = timeDiff * 1000 + 北京时间2024/1/1 00:00:00
        const expireTimestamp = timeDiff * 1000 + startTime.getTime();
        return getServerTime().getTime() >= expireTimestamp;
    }
    return true;
}
/**
 * 检测token是否合法、有效
 * token举例：0fd6fc5704943fc2dc7bb0fee000b1c7ae642f4cf5d11258ce59ecffb1457ed34_01936dd9
 * token字符串组成：不小于32位的小写字母加数字组合字符串 +下划线 + 8位小写字母加数字组合字符串。
 * 后8位字符串为token有效校验码（token有效截止时间-北京时间2024/1/1 00:00:00，转换成了16进制后的固定8位字符串）
 * @param token
 * @returns
 */
function checkLoginToken(token) {
    const ms = token.match(/^([a-z0-9]{32,})_([a-z0-9]{8})$/);
    if (!token) {
        throw new Error('token is empty!');
    }
    if (!ms) {
        throw new Error('token is invalid!');
    }
    if (checkTokenExpired(ms[2])) {
        throw new Error('token is expired!');
    }
}
/**
 * 获取登陆token
 * @returns
 */
export function getLoginToken() {
    const code = urlUtils.getUrlParam(WX_OAUTH_CODE) || '';
    // 如果url上已经带有code，说明之前已经走过auth登陆，此时token大概率已失效，所以无需再token登陆
    const token = code ? '' : urlUtils.getUrlParam(LOGIN_TOKEN) || '';
    // 检测token是否合法有效
    checkLoginToken(token);
    return token;
}
/**
 * 消费掉当前token
 */
export function consumeLoginToken() {
    const token = getLoginToken();
    new Image().src = `${CONSUME_LOGIN_TOKEN_API}?login_token=${token}`;
}
